import namelize from './namelize';

const uppercase = ['iof', 'cdc', 'spf', 'tc', 'rcf', 'ap'];
const lowercase = ['no', 'na', 'com', 'sem'];

const replaceable = {
  vlr: 'valor',
  fin: 'financeira',
  tar: 'tarifa',
  tc: 'tarifa de cadastro',
  avaliacao: 'avaliação',
  protecao: 'proteção',

  'seguro proteção': 'seguro de proteção',
};

export default function expensize(value, options = {}) {
  /* eslint-disable no-param-reassign */
  options.uppercase = uppercase;
  options.lowercase = lowercase;
  /* eslint-enable no-param-reassign */

  return namelize(
    value
      .replace(/\./g, ' ')
      .split(' ')
      .map((word) => {
        if (/^\d+$/.test(word)) return `(${word})`;
        return replaceable[word.toLowerCase()] || word;
      })
      .join(' '),
    options,
  );
}
